<template>
  <div class="verification-code">
    <div class="inner">
      <div
        ref="inputBox"
        class="input-box"
        v-for="(digit, index) in code"
        :key="index"
      >
        <input
          ref="input"
          type="text"
          maxlength="1"
          @keydown.prevent="handleKeyDown($event, index)"
          @focus="handleFocus(index)"
          @blur="handleBlur(index)"
          :class="{ 'disable-input': lock }"
        />
        <div
          class="digit"
          :class="{
            'hide-digit': currentIndex === index && !lock,
            'disable-digit': lock,
          }"
        >
          {{ digit }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { animate } from "motion";
export default {
  name: "VerificationCode",
  data() {
    return {
      code: [],
      input: null,
      currentIndex: 0,
      lock: false,
    };
  },

  methods: {
    // call by external
    clear() {
      this.code = ["", "", "", "", "", ""];
      this.currentIndex = 0;
      this.$nextTick(() => {
        this.$refs.input[0].focus();
      });
    },
    // call by external
    shake() {
      const el = this.$refs.inputBox;
      if (!el) return;

      try {
        animate(
          el,
          {
            transform: [
              "translateX(0px)",
              "translateX(-10px)",
              "translateX(10px)",
              "translateX(0px)",
            ],
          },
          {
            duration: 0.3,
            ease: "easeInOut",
          }
        );
      } catch (error) {
        console.error("Animation failed:", error);
      }
    },
    digit(index) {
      return this.code[index] || "";
    },
    handleFocus(index) {
      this.currentIndex = index;
    },
    handleBlur() {
      this.currentIndex = -1;
    },
    handleKeyDown(event, index) {
      const input = event.target;

      // if input is number, add to code
      if (/^\d$/.test(event.key)) {
        this.code[index] = event.key.toString();
        this.input = this.code.join("");
        if (index < this.code?.length - 1) {
          this.$refs.input[index + 1].focus();
        }
      }

      if (event.key === "Backspace" && input.value.length === 0 && index > 0) {
        this.code[index - 1] = "";
        this.input = this.code.join("");
        this.$refs.input[index - 1].focus();
      }

      this.$emit("keyPressed", { key: event.key, index });
    },
  },
  mounted() {
    this.code = ["", "", "", "", "", ""];
    this.$nextTick(() => {
      this.$refs.input[0].focus();
    });
  },
  watch: {
    input: {
      handler(newValue) {
        if (newValue?.length === 6) {
          this.lock = true;
          setTimeout(() => {
            this.$emit("input", newValue);
            this.lock = false;
          }, 500);
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.verification-code {
  position: relative;
  display: block;
  width: 100%;
  .inner {
    margin-top: 30px;
    position: relative;
    display: flex;
    justify-content: space-between;
    padding: 0;
    width: 100%;
    align-items: center;

    .input-box {
      position: relative;
      width: 40px;
      height: 40px;
      max-width: 40px;
      max-height: 40px;
      font-size: 24px;
      border: 1px solid #ccc;
      border-radius: 4px;
      background-color: #fff;

      input {
        position: absolute;
        max-width: 100%;
        width: 100%;
        max-height: 100%;
        height: 100%;
        text-align: center;
        border: none;
        outline: none;
        font-size: 24px;
        background-color: transparent;
        left: 0;
      }
      .digit {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        pointer-events: none;
        user-select: none;
      }
      .hide-digit {
        visibility: hidden;
      }
      .disable-digit {
        color: #999;
        pointer-events: none;
      }
      .disable-input {
        pointer-events: none;
        user-select: none;
        visibility: collapse;
      }
    }
  }
}
</style>
